import React, { useEffect } from "react";
import { observer, useLocalStore, inject } from "mobx-react";
import { useParams, useRouteMatch } from "react-router-dom";
import styled from "styled-components";

import TabBar from "../TabBar/TabBar";
import Container from "../list/Container";
import Header from "../Header/Header";
import { PackStoreContext } from "./PackStore";
import NotFound from "../common/ErrorMessages";

import FloatingChatButton from "app/Chat/buttons/FloatingChatButton";

// const { default: Header } = require("../Header/Header");
// const appStore = require("../AppStore").default;

function Pack({ store, packLists, dialogsToDom, userStore, assistantStore }) {
  const match = useRouteMatch("/pack/:id/list/:listId");
  const currentListId = match?.params?.listId;
  const { id } = useParams();
  const dashboard = store.pack?.is_dashboard_enabled === '1' ? { name: "Dashboard" , id: "dashboard" } : '';

  const selectedSheet = currentListId != "dashboard" ? match
    ? packLists.find((list) => list.id == match.params.listId)
    : ""
    : dashboard;

  useEffect(() => {
    store.handlePackIdChange(id);
    if (match) {
      store.handleCurrentListIdChange(match.params.listId);
    } else {
      store.openFirstSheet();
    }
  }, [id, match, store, store.lists]);

  useEffect(() => {
    // If user is not admin or owner, hide the assistant chat button
    if (
      !userStore.user ||
      !(userStore.user.isAdminForUsers || userStore.user.isOwner) ||
      id === "system" ||
      store.pack?.is_log_pack == "1" ||
      selectedSheet?.is_log_sheet == "1"
    ) {
      assistantStore.hideAssistantButton();
      return;
    }

    assistantStore.showAssistantButton();
  }, [userStore.user, selectedSheet, store.pack, id]);

  const handleChatButtonClick = () => {
    assistantStore.openChat();
  };

  if (!store.isValidPack) {
    return <NotFound />;
  }

  return (
    <PackStoreContext.Provider value={store}>
      <div
        style={{
          height: "100vh",
          display: "flex",
          flexFlow: "column",
          overflow: "hidden",
          flexGrow: 1,
        }}
      >
        <Header
          packName={store.packName}
          changePackName={store.handlePackNameChange}
          themeColor={store.themeColor}
          changeThemeColor={store.handleThemeColorChange}
          icon={store.icon}
          changeIcon={store.handleIconChange}
        />
        <TabBar
          sheets={dashboard !== '' ? [dashboard, ...packLists] : packLists}
          selectedSheet={selectedSheet}
          renameSheet={async (value) =>
            store.handleRenameSheet(value, selectedSheet)
          }
          themeColor={store.themeColor}
          changeSheet={store.handleChangeSheet}
          onAddSheetBtnClick={store.handleCreateSheet}
          deleteSheet={store.handleDeleteSheet}
          openLogSheet={store.openLogSheet}
          isSheetCreating={store.isSheetCreating}
          duplicateSheet={store.handleDuplicateSheet}
        />
        {currentListId != "dashboard" ? (
          store.lists.map((list) => (
            <ContainerWrapper
              key={list.id}
              themeColor={store.themeColor}
              listId={list.id}
              value={currentListId}
            />
          ))
        ) : (
          <ContainerWrapper
            themeColor={store.themeColor}
            listId={currentListId}
            value={currentListId}
          />
        )}
        {store.lists.length === 0 && !store.isListsLoading && (
          <NoSheetMessage>
            No sheets. To create a sheet click on Add Sheet.
          </NoSheetMessage>
        )}
      </div>
      {assistantStore.isAssistantButtonVisible && (
        <FloatingChatButton onClick={handleChatButtonClick} />
      )}
    </PackStoreContext.Provider>
  );
}

function ContainerWrapper(props) {
  const { children, value, listId, themeColor, ...other } = props;
  const [isVisited, setIsVisited] = React.useState(false);

  if (value === listId && !isVisited) {
    setIsVisited(true);
  }

  return (
    <StyledDiv
      role="tabpanel"
      hidden={value !== listId}
      {...other}
      style={{ width: "auto", height: "auto" }}
      key={listId}
    >
      {isVisited && (
        <Container key={listId} themeColor={themeColor} listId={listId} />
      )}
    </StyledDiv>
  );
}

const StyledDiv = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

const NoSheetMessage = styled.div`
  width: 100%;
  text-align: center;
  opacity: 0.6;
  margin-top: 100px;
`;

export default inject(({ store: appStore }) => ({
  store: appStore.packStore,
  packLists: appStore.leftHoverMenuStore.packLists,
  chatStore: appStore.chatStore,
  assistantStore: appStore.assistantStore,
  userStore: appStore.userStore,
}))(observer(Pack));
